import { NodeTypeName } from "@app/types";
import BaseNodeModel from "../BaseNodeModel";
import { Constant } from '../../const';
import ObjectUsedIn from "../../utilities/usedIn/ObjectsUsedIn";

export default class SessionNodeModel extends BaseNodeModel {
    /**
     * Input node model
     * @module SessionNodeModel
     * @param {string} nodeName Node display name
     * @param {number} x Node x coordinate on canvas
     * @param {number} y Node y coordinate on canvas
     * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
     * @param {string} id If non-null, use this ID as the node ID
     */
    constructor(nodeName = "UNTITLED_NODE", x = 0, y = 0, props = null, id = null) {
        super(nodeName, x, y, null, id);
        this.props.nodeTypeName = NodeTypeName.session;
        this.props.colorClass = "yellow";
        this.props.iconClass = "external-link";
        // default configuration fields
        this.props.config = {};
        // used in configViews
        this.props.config['description'] = props.config.description || '';
        this.props.config["channelName"] = props.config.channel || "VOICE"; // string array
        this.props.config["destination"] = null; // variable
        this.props.config["startModule"] = null; // module
        this.DEFAULT_COLOR_CLASS = "yellow";
        this.getModuleOptions = this.getModuleOptions.bind(this);
        this.applyProps(props);
    }

    getModuleOptions() {
        const modules = window.apm.knowledgeBase.getModules();
        modules.splice(modules[0],1);

        return modules.sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    };

    setConfig(key, value) {

        if(key === 'destination' && value !== ''){
            const checkVariable = this.isValidVariable(value);

            if(!checkVariable.isValidVar) {
                return;
            } else {
                super.setConfig(key, value);
            }
        }

        else if(key === "startModule"){
            const moduleName = window.apm.serialized.components.modules.find(mod => mod.id === value).name || "UNKNOWN"
            
            this.props.config.startModule = moduleName;
        }

        else {
            super.setConfig(key, value);

        }
        
        document.dispatchEvent(new CustomEvent("ev-property-refresh"));
    }

    /**
     * Returns if is valid variable, prevents user typing in non-existing variable names
     * @returns Boolean
     */
     isValidVariable(variable) {

        // Define toast error strings
        const varNotFound = "Variable "+variable+" not found";
        const varSensitive = "Session nodes cannot contain variables marked with Sensitive data";
        
        const splitVarName = variable.split(".");
        const checkVariable = {};
        // if variable not found then this will always be false
        checkVariable['isValidVar'] = false;
        this.varError = varNotFound;

        // application variables
        if (splitVarName[0] === Constant.k.SCOPE_APPLICATION && window.apm.getVariable(splitVarName[1])) {
            var appVariable = window.apm.getVariable(splitVarName[1]);
            checkVariable['varId'] = appVariable.id;

            if(!appVariable.props.config.sensitiveData){
                checkVariable['isValidVar'] = true;
                this.varError = '';
            } else {
                this.varError = varSensitive;
            }
        }

        // local variables
        if (splitVarName[0] === Constant.k.SCOPE_MODULE) {
            
            const componentUsedIn = ObjectUsedIn.getObjectUsedIn(this.props.parentComponentID, window.apm.serialized);
            if (componentUsedIn[0].length > 0) {
                componentUsedIn[0].forEach(m => {
                    const module = window.apm.serialized.components.modules.find(mo => mo.id === m);
                    
                    if (module) {
                        const node = module.versions[1].flow.nodes.find(n => n.props.parentComponentID === this.props.parentComponentID)

                        if (node) {
                            var modVariable = window.apm.getVariable(splitVarName[1], module.id);
                            
                            if (modVariable) {
                                checkVariable['varId'] = modVariable.id;
                                
                                if(!modVariable.props.config.sensitiveData){
                                    checkVariable['isValidVar'] = true;
                                    this.varError = '';
                                } else {
                                    this.varError = varSensitive;
                                }
                            }

                        }
                    }
                });
            }
        }

        return checkVariable;
    }

    getConfigViews() {
        const { channelNameOptions } = window.apm.getChannelOptions();
        this.props.configView = [
            {
                type: "Dropdown",
                label: "Channel Name",
                key: "channelName",
                optionName: "Select channel name",
                options: channelNameOptions
            },
            {
                type: "Input", 
                suggestion: "variable", 
                label: "Destination", 
                key: "destination", 
                hint: "Destination",
                valRules: {"varName": true},
                excludeSensitiveVariables: true
            },
            {
                type: "Dropdown",
                label: "Start Module",
                key: "startModule",
                optionName: window.l.settings.select_module,
                options: this.getModuleOptions(),
                sel: this.getModuleOptions().findIndex(mod => mod.name === this.props.config.startModule),
                removable: true
            }
        ];
        
        return [
            ...this.getConfigViewNameField(),
            ...[
                {type: "Textarea", label: this.getPropLabel("description"), key: "description", valRules: { "noEmpty": true }}
            ],
            ...this.props.configView,
            ...[
                { type: "hr" },
                { type: "Textarea", label: this.getPropLabel("note"), key: "note"}
            ]
        ];
    }
}
